import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { metaSchemas } from "@/lib/constants";
import { channelsSort, genreSort, searchSort, searchTvShowSort, titlesSort } from "@/lib/sorts";
import merge from "deepmerge";
import LogicaAPI from "./logicaapi";
class Meta extends LogicaAPI {
  howtoPlay(id) {
    const params = {
      app_id: this.config.appId,
      device_code: this.config.deviceCode,
      with_howto_acquisition: true,
      expand_object_flag: true
    };
    return this.get(`/api/v1/metas/${id}/howto_play`, {
      params
    });
  }
  children(_ref) {
    let {
      id,
      offset,
      limit,
      filter = {},
      sort = []
    } = _ref;
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      expand_object_flag: false,
      with_total_count: true,
      condition: merge(_objectSpread({
        meta_schema_id: metaSchemas.episode.id,
        "values.tv_show": id,
        time_range: {
          delivery_end_at: {
            gt: "now"
          }
        }
      }, this.dsearchCommonCondition), filter),
      sort: merge([{
        "values.num": "asc"
      }, {
        delivery_start_at: "asc"
      }, {
        id: "desc"
      }], sort),
      from: offset,
      limit
    });
    return this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
  }
  channels(_ref2) {
    let {
      offset,
      limit,
      filter = {},
      sort = "pr"
    } = _ref2;
    let sortOrder;
    if (sort == "mylist") {
      sortOrder = {
        sort: [{
          entitled_at: "desc"
        }, {
          id: "desc"
        }]
      };
    } else {
      sortOrder = channelsSort.find(v => v.value == sort);
    }
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      expand_object_flag: false,
      with_total_count: true,
      condition: merge(_objectSpread({
        meta_schema_id: metaSchemas.channel.id
      }, this.dsearchCommonCondition), filter),
      sort: sortOrder.sort,
      from: offset,
      limit
    });
    return this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
  }
  channelFeatureEpisodes(_ref3) {
    let {
      id,
      offset,
      limit
    } = _ref3;
    // vod、live、見逃し全て含める
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      expand_object_flag: false,
      with_total_count: true,
      condition: _objectSpread({
        meta_schema_id: metaSchemas.episode.id,
        "values.channel": id,
        time_range: {
          delivery_end_at: {
            gt: "now"
          }
        }
      }, this.dsearchCommonCondition),
      sort: [{
        push_rank: "desc"
      }, {
        name: "asc"
      }, {
        id: "desc"
      }],
      from: offset,
      limit
    });
    return this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
  }
  async channelDetail(id) {
    var _res$metas;
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      condition: _objectSpread({
        meta_schema_id: metaSchemas.channel.id,
        id
      }, this.dsearchCommonCondition)
    });
    const res = await this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
    return res === null || res === void 0 || (_res$metas = res.metas) === null || _res$metas === void 0 ? void 0 : _res$metas[0];
  }
  async searchEpisode(_ref4) {
    let {
      keyword,
      filter = {},
      sort = "rel",
      offset,
      limit,
      minScore = null
    } = _ref4;
    const sortOrder = searchSort.find(v => v.value == sort);
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      with_total_count: true,
      keyword,
      condition: merge(_objectSpread({
        meta_schema_id: metaSchemas.episode.id,
        time_range: {
          delivery_end_at: {
            gt: "now"
          }
        }
      }, this.dsearchCommonCondition), filter),
      sort: sortOrder.sort,
      from: offset,
      limit
    });
    if (!!minScore) {
      params.min_score = minScore;
    }
    return await this.get("/api/v1/metas/dsearch", {
      params: {
        q: JSON.stringify(params)
      }
    });
  }
  async searchTvShow(_ref5) {
    let {
      keyword,
      filter = {},
      sort = "rel",
      offset,
      limit,
      minScore = null
    } = _ref5;
    const sortOrder = searchTvShowSort.find(v => v.value == sort);
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      with_total_count: true,
      keyword,
      condition: merge(_objectSpread({
        meta_schema_id: metaSchemas.tvshow.id
      }, this.dsearchCommonCondition), filter),
      sort: sortOrder.sort,
      from: offset,
      limit
    });
    if (!!minScore) {
      params.min_score = minScore;
    }
    return await this.get("/api/v1/metas/dsearch", {
      params: {
        q: JSON.stringify(params)
      }
    });
  }
  channelLiveSchedule(_ref6) {
    let {
      id,
      day,
      offset,
      limit
    } = _ref6;
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      expand_object_flag: false,
      with_total_count: true,
      condition: _objectSpread({
        meta_schema_id: metaSchemas.episode.id,
        "values.channel": id,
        time_range: {
          delivery_start_at: {
            gte: `${day} 00:00:00`,
            lte: `${day} 23:59:59`
          }
        }
      }, this.dsearchCommonCondition),
      sort: [{
        delivery_start_at: "asc"
      }, {
        push_rank: "desc"
      }, {
        id: "desc"
      }],
      from: offset,
      limit
    });
    return this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
  }
  async channelLinearEpisodes(_ref7) {
    let {
      id,
      offset,
      limit,
      filter = {}
    } = _ref7;
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      expand_object_flag: false,
      with_total_count: true,
      condition: merge(_objectSpread({
        meta_schema_id: metaSchemas.episode.id,
        "values.channel": id,
        "values.is_live": true,
        time_range: {
          delivery_end_at: {
            gt: "now"
          },
          "values.encode_end_date": {
            gt: "now"
          }
        },
        not: {
          "values.source_epg_id": null
        }
      }, this.dsearchCommonCondition), filter),
      sort: [{
        delivery_start_at: "asc"
      }, {
        id: "desc"
      }],
      from: offset,
      limit
    });
    return await this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
  }
  async title(id) {
    var _res$metas2;
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      condition: _objectSpread({
        meta_schema_id: metaSchemas.tvshow.id,
        id
      }, this.dsearchCommonCondition)
    });
    const res = await this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
    return res === null || res === void 0 || (_res$metas2 = res.metas) === null || _res$metas2 === void 0 ? void 0 : _res$metas2[0];
  }
  async titles(_ref8) {
    let {
      filter = {},
      sort = "pr",
      offset,
      limit
    } = _ref8;
    const sortOrder = titlesSort.find(v => v.value === sort);
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      with_total_count: true,
      condition: merge(_objectSpread({
        meta_schema_id: metaSchemas.tvshow.id
      }, this.dsearchCommonCondition), filter),
      sort: sortOrder.sort,
      from: offset,
      limit
    });
    return this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
  }
  entitled(_ref9) {
    let {
      channelId,
      contentType,
      offset,
      limit
    } = _ref9;
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      condition: _objectSpread(_objectSpread({
        is_entitled: true,
        time_range: {
          delivery_end_at: {
            gt: "now"
          }
        }
      }, this.dsearchCommonCondition), this.dsearchContentTypeCondition(contentType)),
      from: offset,
      limit: limit,
      sort: [{
        entitled_at: "desc"
      }, {
        "values.num": "asc"
      }, {
        id: "desc"
      }],
      with_total_count: true
    });
    if (channelId) {
      params.condition["values.channel"] = channelId;
    }
    return this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
  }
  getEntitledStoreEpisodes(args) {
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      condition: _objectSpread({
        meta_schema_id: metaSchemas.episode.id,
        is_entitled: true,
        time_range: {
          delivery_end_at: {
            gt: "now"
          }
        },
        "values.channel": this.config.storeId
      }, this.dsearchCommonCondition),
      from: args.offset,
      limit: args.limit,
      sort: [{
        entitled_at: "desc"
      }, {
        "values.num": "asc"
      }, {
        id: "desc"
      }],
      with_total_count: true
    });
    const res = this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
    return res;
  }
  genrePaletteEpisodes(_ref10) {
    let {
      channel,
      genre,
      offset,
      limit,
      sortOrder,
      type
    } = _ref10;
    const sort = genreSort.find(v => v.value == sortOrder);
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      condition: _objectSpread({
        meta_schema_id: metaSchemas.episode.id
      }, this.dsearchCommonCondition),
      from: offset,
      limit: limit,
      sort: sort.sort,
      with_total_count: true
    });
    if (channel) {
      params.condition["values.channel"] = channel;
    }
    if (genre && genre.length > 0 && type === "id") {
      params.condition["values.genres"] = genre;
    } else if (genre && genre.length > 0 && type === "not-id") {
      params.condition["not"] = {
        "values.genres": genre
      };
    }
    const res = this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
    return res;
  }
  searchFromId(ids, limit) {
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      condition: _objectSpread({
        id: ids
      }, this.dsearchCommonCondition),
      limit
    });
    return this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
  }
  searchFromRightId(rightId) {
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      condition: {
        meta_schema_id: metaSchemas.episode.id,
        nested: {
          path: "right_metas",
          condition: {
            "right_metas.right_id": rightId
          }
        }
      },
      limit: 1
    });
    return this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
  }
  rankingSearch(channel, target, range, limit) {
    const order = (() => {
      if (range === "1week") {
        return "weekly_ranking";
      } else if (range === "1month") {
        return "monthly_ranking";
      } else if (range === "1day") {
        return "daily_ranking";
      }
    })();
    const params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
      condition: _objectSpread({
        meta_schema_id: metaSchemas.episode.id
      }, this.dsearchCommonCondition),
      sort: [{
        [target]: order
      }],
      limit
    });
    if (channel) {
      params.condition["values.channel"] = channel;
    }
    return this.get(`/api/v1/metas/dsearch`, {
      params: {
        q: JSON.stringify(params)
      }
    });
  }
  async getRooms(metaId) {
    return this.get(`/api/v1/metas/${metaId}/meta_rooms`);
  }
}
export default Meta;